import {createAction, props} from "@ngrx/store";
import {DiscountModel} from "../_models/discount.model";

export const DiscountCreated = createAction('[Discount List Page] discount Created ',props<{discount: DiscountModel}>());
export const DiscountCreatedSuccessfully = createAction('[Discount List Page] discount Created Successfully ',props<{response: any}>());
export const DiscountCreationFailed = createAction('[Discount List Page] discount Creation Failed ',props<{error: any}>());


